import script from "./editor.vue?vue&type=script&setup=true&name=WangEditor&lang=ts"
export * from "./editor.vue?vue&type=script&setup=true&name=WangEditor&lang=ts"

import "./editor.vue?vue&type=style&index=0&id=53704397&lang=scss"

const __exports__ = script;

export default __exports__